import { Api } from "./Api.class";
const endpoint = "works";
const worksAPI = new Api(endpoint);
export default worksAPI;
